<div class="head">
  <h1 class="page-title">Transactions</h1>
  <button class="review-chip" *ngIf="reviewCount"
          (click)="filters.uncategorizedOnly = !filters.uncategorizedOnly"
          [class.on]="filters.uncategorizedOnly">
    {{ reviewCount }} to review
  </button>
</div>

<p class="commit-error" *ngIf="error">{{ error }}</p>

<div class="backlog" *ngIf="backlog.length">
  <span class="backlog-lbl">To review:</span>
  <button class="chip" *ngFor="let b of backlog; trackBy: trackBacklog"
          [class.on]="chipActive(b.month)" (click)="openBacklog(b.month)">
    {{ b.month + '-01T00:00:00' | date:'MMM yy' }} · {{ b.count }}
  </button>
</div>

<div class="filters">
  <select [(ngModel)]="filters.month">
    <option value="">All months</option>
    <option *ngFor="let m of months; trackBy: trackMonth" [value]="m">{{ m + '-01T00:00:00' | date:'MMM yyyy' }}</option>
  </select>

  <select [(ngModel)]="filters.accountId">
    <option value="">All accounts</option>
    <option *ngFor="let a of accounts; trackBy: trackAccount" [value]="a.id">{{ a.name }}</option>
  </select>

  <select [(ngModel)]="filters.categoryId">
    <option value="">All categories</option>
    <option *ngFor="let c of categories; trackBy: trackCategory" [value]="c.id">{{ c.name }}</option>
  </select>

  <input class="search" type="search" [(ngModel)]="filters.search" placeholder="Search description, merchant, note, or amount…">

  <label class="check">
    <input type="checkbox" [(ngModel)]="filters.showTransfers"> Show transfers
  </label>

  <label class="check">
    <input type="checkbox" [(ngModel)]="filters.spendingOnly"> Spending only
  </label>
</div>

<div class="rule-offer" *ngFor="let offer of ruleOffers; trackBy: trackOfferPattern">
  <span>
    Always categorize <code>{{ offer.pattern }}</code>
    as <b>{{ categoryName(offer.categoryId) }}</b>?
    <em *ngIf="offer.count > 1">Also applies to {{ offer.count }} uncategorized.</em>
  </span>
  <button class="accept" (click)="acceptRuleOffer(offer)">Remember</button>
  <button class="link-btn" (click)="dismissRuleOffer(offer)">no thanks</button>
</div>

<div class="rule-offer" *ngIf="transferOffer">
  <span>
    Always treat <code>{{ transferOffer.pattern }}</code> as a <b>transfer</b>?
    <em *ngIf="transferOffer.count">Also applies to {{ transferOffer.count }} more.</em>
  </span>
  <button class="accept" (click)="acceptTransferOffer()">Remember</button>
  <button class="link-btn" (click)="dismissTransferOffer()">no thanks</button>
</div>

<div class="bulk-bar" *ngIf="selected.size">
  <span>{{ selected.size }} selected</span>
  <select [(ngModel)]="bulkCategoryId">
    <option value="">Choose category…</option>
    <option *ngFor="let c of categories; trackBy: trackCategory" [value]="c.id">{{ c.name }}</option>
  </select>
  <button class="accept" (click)="applyBulk()">Apply</button>
</div>

<cdk-virtual-scroll-viewport itemSize="30" class="ledger">
  <div class="txn" *cdkVirtualFor="let t of visible; trackBy: trackById"
       [class.excluded]="t.excluded">
    <input type="checkbox" [checked]="selected.has(t.id)" (change)="toggle(t.id)">
    <span class="date">{{ t.date + 'T00:00:00' | date:'MMM d' }}</span>
    <span class="desc" [title]="t.description">{{ t.matchKey }}</span>

    <select class="cat-select"
            (change)="setCategory(t, $any($event.target).value)">
      <option value="" [selected]="!t.categoryId">Uncategorized</option>
      <option *ngFor="let c of categories; trackBy: trackCategory"
              [value]="c.id" [selected]="c.id === t.categoryId">{{ c.name }}</option>
    </select>

    <button class="flag" [class.on]="t.isTransfer" (click)="toggleTransfer(t)" title="Transfer">⇄</button>
    <button class="flag" [class.on]="t.excluded" (click)="toggleExcluded(t)" title="Exclude">∅</button>
    <button class="flag" (click)="markRecurring(t)" title="Mark recurring">↻</button>

    <span class="amount" [class.inflow]="t.amount > 0">{{ t.amount / 100 | currency:'USD' }}</span>
  </div>
</cdk-virtual-scroll-viewport>

<p class="empty" *ngIf="visible.length === 0">
  Nothing here. Import a CSV to get started.
</p>
